import { TableCell, TableHeader } from '@tiptap/extension-table';

import { Attributes } from '@tiptap/core';
import { getHexCodeFromName } from '../../../ColorPalette';

export interface TableCellAttributes {
  borderTop: boolean;
  borderLeft: boolean;
  borderBottom: boolean;
  borderRight: boolean;
  backgroundColor: string;
  verticalAlign: 'top' | 'middle' | 'bottom';
}

const CustomTableCellAttributes = (): Attributes => {
  return {
    borderTop: {
      default: true,
      keepOnSplit: true,
      renderHTML: (attributes) => {
        return {
          style: `${attributes.borderTop === false ? 'border-top-width: 0;' : ''}`,
        };
      },
    },
    borderLeft: {
      default: true,
      keepOnSplit: true,
      renderHTML: (attributes) => {
        return {
          style: `${attributes.borderLeft === false ? 'border-left-width: 0;' : ''}`,
        };
      },
    },
    borderBottom: {
      default: true,
      keepOnSplit: true,
      renderHTML: (attributes) => {
        return {
          style: `${attributes.borderBottom === false ? 'border-bottom-width: 0;' : ''}`,
        };
      },
    },
    borderRight: {
      default: true,
      keepOnSplit: true,
      renderHTML: (attributes) => {
        return {
          style: `${attributes.borderRight === false ? 'border-right-width: 0;' : ''}`,
        };
      },
    },
    backgroundColor: {
      default: '',
      renderHTML: (attributes) => {
        return { style: `background-color: ${getHexCodeFromName(attributes.backgroundColor, 'light')};` };
      },
    },
    verticalAlign: {
      default: 'top',
      keepOnSplit: true,
      renderHTML: (attributes) => {
        return {
          style: `vertical-align: ${attributes.verticalAlign};`,
        };
      },
    },
  };
};

export const CustomTableCell = TableCell.extend({
  content: '(paragraph|bulletList|orderedList|imageFigure|tableFigure)+',
  addAttributes() {
    return {
      ...this.parent?.(),
      ...CustomTableCellAttributes(),
    };
  },
});

export const CustomTableHeader = TableHeader.extend({
  content: '(paragraph|bulletList|orderedList|imageFigure|tableFigure)+',
  addAttributes() {
    return {
      ...this.parent?.(),
      ...CustomTableCellAttributes(),
    };
  },
});
